<template lang="pug">
.new-customer-counpon(v-if="newCustomerData&& newCustomerData.moduleData&&newCustomerData.moduleData.propList")
  .new-customer-title
    img(src="https://m.hellobike.com/resource/gallery/61/nYL-suBw_Group%201707482844.png?x-oss-process=image/quality,q_80")
  .new-customer-content
    .new-customer-content-item(v-for="(item,index) in list")
      .new-customer-title {{item.goodsPropDesc}}
      .new-customer-word
        .new-customer-money {{item.amount}}
        .new-customer-unit {{item.unit }}
      .new-customer-info {{item.subNewWord}}
      .new-customer-btn(@click="goUrl(item)") {{item.btnName}}
</template>
<script>
import { startApp } from '@/utils/index';
import { env } from '@hb/hbridge';

export default {
  props: {
    newCustomerData: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      config: {
        deepLink:
          'https://m.hellobike.com/mf/spa/u_wsjczx/latest/MA2204243054087163443937280.html?activityCode=MA2204243054087163443937280&beyondMP=true&chInfo=ch_share__chsub_CopyLink&fxzjshareChinfo=ch_share__chsub_CopyLink&apshareid=DAEF5627-8D33-4E6E-9CE2-2A0FD137329B&shareBizType=mrfxzw',
        wechatLink: 'https://m.hellobike.com/mf/spa/u_sxnpet/latest/MA2412037285359647643402840.html?activityCode=MA2412037285359647643402840',
      },
      list: [],
    };
  },
  watch: {
    newCustomerData: {
      handler(val) {
        if (val && val.moduleData && val.moduleData.propList) {
          this.list = val.moduleData.propList;
        }
      },
    },
  },
  mounted() {
    if (this.newCustomerData && this.newCustomerData.moduleData) {
      this.list = this.newCustomerData.moduleData.propList;
    } else {
      this.list = [];
    }
  },
  methods: {
    goUrl(url) {
      if (env.isAliMP || env.isAliMPMonitor) {
        startApp(this.config.deepLink);
        return;
      }
      window.location.href = url.propUrl;
    },
  },
};
</script>
<style lang="less" scoped>
.new-customer-counpon {
  width: 3.51rem;
  height: 1.4rem;
  border-radius: 0.16rem;
  background: linear-gradient(66.16deg, #ff4000 15.32%, #ff7824 84.68%);

  .new-customer-title {
    img {
      width: 1.91rem;
      height: 0.35rem;
    }
  }

  .new-customer-content {
    display: flex;
    margin-left: 0.08rem;
    margin-top: -0.06rem;
    overflow: auto;

    .new-customer-content-item {
      width: 0.74rem;
      height: 1rem;
      margin-right: 0.06rem;
      background-image: url(https://m.hellobike.com/resource/gallery/61/WPx7g5iUze.png?x-oss-process=image/quality,q_80);
      background-size: 100% 100%;
      padding-top: 0.0375rem;
      flex-shrink: 0;

      .new-customer-title {
        font-family: PingFang SC;
        font-size: 0.12rem;
        font-weight: 500;
        line-height: 0.12rem;
        text-align: center;
        color: #f25124;
      }

      .new-customer-word {
        display: flex;
        color: #ff5526;
        justify-content: center;
        margin-top: 0.0446rem;

        .new-customer-money {
          font-family: DIN Alternate;
          font-size: 0.26rem;
          font-weight: 700;
          line-height: 0.3027rem;
        }

        .new-customer-unit {
          font-family: PingFang SC;
          font-size: 0.12rem;
          font-weight: 400;
          line-height: 0.168rem;
          margin-top: 0.1rem;
        }
      }

      .new-customer-info {
        color: #6c747a;
        font-family: PingFang SC;
        font-size: 0.11rem;
        font-weight: 400;
        line-height: 0.154rem;
        text-align: center;
      }

      .new-customer-btn {
        width: 0.54rem;
        height: 0.2rem;
        background: #ff5526;
        text-align: center;
        border-radius: 5rem;
        line-height: 0.2rem;
        font-family: PingFang SC;
        font-size: 0.12rem;
        font-weight: 500;
        line-height: 0.2rem;
        color: #fff;
        margin: 0.09rem auto 0 auto;
      }
    }
  }

  .new-customer-content::-webkit-scrollbar {
    display: none;
  }
}
</style>
